let titleInterval = null;

export function startTitleRotation(stationName, metadata) {
  stopTitleRotation(); // Pulisci eventuali intervalli esistenti
  
  const parts = metadata?.split('-') || [];
  const title = parts[0]?.trim();
  const artist = parts[1]?.trim();
  const year = parts[3]?.trim();
  
  const infos = [stationName, title, artist, year].filter(Boolean);
  
  if (infos.length <= 1) {
    document.title = stationName || 'Radio Player';
    return;
  }

  let currentIndex = 0;
  document.title = infos[currentIndex];
  
  titleInterval = setInterval(() => {
    currentIndex = (currentIndex + 1) % infos.length;
    document.title = infos[currentIndex];
  }, 1500); 
}

export function stopTitleRotation() {
  if (titleInterval) {
    clearInterval(titleInterval);
    titleInterval = null;
  }
}